import { useEffect, useRef, useState } from 'react';

const DEBOUNCE_MS = 300;

/** A text filter that reports its value DEBOUNCE_MS after the last keystroke;
 * `value` (from the URL) re-seeds it when it changes from outside. */
export function DebouncedInput({
  value,
  onChange,
  placeholder,
  label,
  className = '',
}: {
  value: string;
  onChange: (next: string) => void;
  placeholder: string;
  label: string;
  className?: string;
}) {
  const [draft, setDraft] = useState(value);
  const latest = useRef({ value, onChange });
  latest.current = { value, onChange };

  useEffect(() => setDraft(value), [value]);
  useEffect(() => {
    if (draft === latest.current.value) return;
    const id = setTimeout(() => latest.current.onChange(draft), DEBOUNCE_MS);
    return () => clearTimeout(id);
  }, [draft]);

  return (
    <label className={`flex flex-col gap-1 text-meta text-fg-secondary ${className}`}>
      {label}
      <input
        type="search"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        placeholder={placeholder}
        className="rounded-card border border-border bg-background h-7 px-3 py-1 text-meta text-fg-primary"
      />
    </label>
  );
}
